import { useQuery, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import {
  ApplicantUserDetailsInput,
  ApplicantUserPersonalInformation,
  Entity,
  StaffApplicantProfileApplyToEditContainerApplicantUserDocument,
  StaffApplicantProfileApplyToEditContainerApplicantUserUpdateDocument,
  StaffApplicantProfileApplyToEditContainerApplicantUserUpdateMutationVariables,
  StaffApplicantProfileApplyToEditContainerEntitiesDocument,
} from "../../../../generated";
import { message } from "antd";
import { ApplicantProfileApplyToEdit } from "./applicant-profile-apply-to-edit";
import { ComponentQueryLoader } from "../../../shared/component-query-loader";
 
interface ApplicantProfileApplyToEditContainerProps {
  applicantId: string;
}

export const ApplicantProfileApplyToEditContainer: React.FC<ApplicantProfileApplyToEditContainerProps> = ({applicantId}) => {
  const navigate = useNavigate();

  // Query to get the applicant's applying to data
  const {
    data: applyingToData,
    loading: applyingToLoading,
    error: applyingToError,
  } = useQuery(StaffApplicantProfileApplyToEditContainerApplicantUserDocument, {
    variables: {
      id: applicantId,
    },
  });

  // Query to get the entities data
  const { data: entityData, loading: entityLoading, error: entityError } = useQuery(StaffApplicantProfileApplyToEditContainerEntitiesDocument);

  // Mutation to update the applicant's applying to data
  const [applicantUserUpdate] = useMutation(StaffApplicantProfileApplyToEditContainerApplicantUserUpdateDocument);

  // Function to handle the save action
  const handleSave = async (data: ApplicantUserDetailsInput) => {
    // console.log("data to be updated: ", data);
    const applicantUserUpdateInputData: StaffApplicantProfileApplyToEditContainerApplicantUserUpdateMutationVariables = {
      input: {
        id: applicantId,
        applicantUserDetails: data,
      },
    };
    try {
      const updateResult = await applicantUserUpdate({
        variables: applicantUserUpdateInputData,
      });
      if (updateResult.data?.applicantUserUpdate) {
        message.success("Organization details updated successfully");
        handleEdit();
      } else {
        message.error("Failed to update organization details");
      }
    } catch (error) {
      message.error(`Error updating organization details`);
    }
  };

  const handleEdit = () => {
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/\/[^/]+$/, "/view");
    navigate(newPath);
  };

  const filteredEntities = entityData?.entities?.filter((entity) => entity?.isClient) || [];

  return (
    <ComponentQueryLoader
      loading={applyingToLoading || entityLoading}
      error={applyingToError || entityError}
      hasData={applyingToData && entityData}
      hasDataComponent={
        <ApplicantProfileApplyToEdit
          onCancel={handleEdit}
          data={applyingToData?.applicantUser?.personalInformation as ApplicantUserPersonalInformation}
          entities={filteredEntities as Entity[]}
          onEditToggle={handleEdit}
          onSave={handleSave}
        />
      }
    />
  );
};
